function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   ", " {\n      display: ", ";\n      position: absolute;\n      top: ", ";\n      right: 0;\n      padding: 0;\n      background-color: ", ";\n      box-shadow: -1px 5px 5px 0 hsla(222, 34%, 7%, 0.07);\n      height: ", ";\n      min-width: 250px;\n\n      ", " {\n         position: static;\n         box-shadow: none;\n      }\n   }\n\n   ", " {\n      ", ", ", " {\n         display: block;\n         width: 100%;\n      }\n   }\n\n   ", " {\n      ", " {\n         display: block;\n         position: static;\n         background-color: transparent;\n         box-shadow: none;\n         height: auto;\n         padding: 0 1rem;\n         overflow: visible;\n\n         ", " {\n            position: absolute;\n            border: 1px solid ", ";\n            box-shadow: -1px 5px 5px 0 hsla(222, 34%, 7%, 0.07);\n\n            ", " {\n               &::after {\n                  display: inline-block;\n                  top: 3px;\n                  border-top: 7px solid transparent;\n                  border-bottom: 7px solid transparent;\n\n                  border-left: 6px solid\n                     ", ";\n               }\n            }\n\n            ", " {\n               padding-left: 0;\n               transform: translateX(100%);\n               top: 0;\n            }\n         }\n      }\n\n      ", " {\n         ", ", ", " {\n            display: inline-block;\n            width: auto;\n         }\n      }\n\n      ", " {\n         color: ", ";\n\n         &:hover,\n         &:focus,\n         &:active {\n            outline: none;\n            color: ", ";\n            border-bottom-color: ", ";\n         }\n\n         &::after {\n            position: relative;\n            top: 13px;\n            right: 0;\n            border-top-color: ", ";\n         }\n      }\n\n      ", " {\n         ", " {\n            color: ", ";\n\n            &:hover,\n            &:focus,\n            &:active {\n               color: ", ";\n            }\n         }\n      }\n\n      ", " {\n         display: none;\n      }\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InnerSiteHeaderWrapper } from './siteHeader/InnerSiteHeaderWrapper';
import { SiteHeaderLeftWrapper } from './siteHeader/SiteHeaderLeftWrapper';
import { SiteHeaderLogoLink } from './siteHeader/SiteHeaderLogoLink';
import { SiteHeaderRightWrapper } from './siteHeader/SiteHeaderRightWrapper';
import { SiteHeaderShell } from './siteHeader/SiteHeaderShell';
import { TopNav } from './siteHeader/TopNav';
import { TopNavCollapsibleMenu } from './siteHeader/TopNavCollapsibleMenu';
import { TopNavMenu } from './siteHeader/TopNavMenu';
import { TopNavMenuItem } from './siteHeader/TopNavMenuItem';
import { TopNavMenuLink } from './siteHeader/TopNavMenuLink';
import { TopNavSubmenu, SubmenuMenu } from './siteHeader/TopNavSubmenu';
import { TopNavUserLink } from './siteHeader/TopNavUserLink';
import { TopNavHamburgerButton } from './siteHeader/TopNavHamburgerButton';
import { TopNavHamburgerButtonWrapper } from './siteHeader/TopNavHamburgerButtonWrapper';
import { createBreakpoint } from '../util/createBreakpoint';
import { SiteHeaderContext } from './siteHeader/SiteHeaderContext';
var Wrapper = styled(InnerSiteHeaderWrapper)(_templateObject(), TopNavCollapsibleMenu, function (_ref) {
  var mobileMenuOpen = _ref.mobileMenuOpen;
  return mobileMenuOpen ? 'block' : 'none';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizes.siteHeaderHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.brandColors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "calc(100vh - ".concat(theme.sizes.siteHeaderHeight, ")");
}, SubmenuMenu, TopNavCollapsibleMenu, TopNavMenuItem, TopNavMenuLink, function (_ref5) {
  var theme = _ref5.theme,
      expandMenuAt = _ref5.expandMenuAt;
  return createBreakpoint('above', expandMenuAt, theme);
}, TopNavCollapsibleMenu, SubmenuMenu, function (_ref6) {
  var theme = _ref6.theme;
  return theme.brandColors.extraLightGray;
}, TopNavMenuLink, function (_ref7) {
  var theme = _ref7.theme;
  return theme.brandColors.mediumLightGray;
}, SubmenuMenu, TopNavCollapsibleMenu, TopNavMenuItem, TopNavMenuLink, TopNavMenuLink, function (_ref8) {
  var theme = _ref8.theme;
  return theme.brandColors.white;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.semanticColors.secondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.semanticColors.secondary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.brandColors.white;
}, SubmenuMenu, TopNavMenuLink, function (_ref12) {
  var theme = _ref12.theme;
  return theme.brandColors.darkGray;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.brandColors.darkGray;
}, TopNavHamburgerButtonWrapper);

var SiteHeader = function SiteHeader(_ref14) {
  var children = _ref14.children,
      expandMenuAt = _ref14.expandMenuAt,
      fixed = _ref14.fixed;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mobileMenuOpen = _useState2[0],
      setMobileMenuOpen = _useState2[1];

  var wrapperRef = useRef();

  var handleBlur = function handleBlur(e) {
    if (!(e.relatedTarget === document.querySelector('[data-rcl-hamburger-button]') || _toConsumableArray(document.querySelectorAll('[data-rcl-collapsible-menu]')).find(function (node) {
      return node.contains(e.relatedTarget);
    }))) {
      setMobileMenuOpen(false);
    }
  };

  useEffect(function () {
    var handleDomClick = function handleDomClick(_ref15) {
      var target = _ref15.target;

      if (mobileMenuOpen && target && target.nodeName === 'A' || wrapperRef && !wrapperRef.current.contains(target)) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', handleDomClick);
    return function () {
      return document.removeEventListener('click', handleDomClick);
    }; // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/React.createElement(SiteHeaderContext.Provider, {
    value: {
      mobileMenuOpen: mobileMenuOpen,
      setMobileMenuOpen: setMobileMenuOpen,
      expandMenuAt: expandMenuAt
    }
  }, /*#__PURE__*/React.createElement(SiteHeaderShell, {
    fixed: fixed,
    onBlur: handleBlur
  }, /*#__PURE__*/React.createElement(Wrapper, {
    mobileMenuOpen: mobileMenuOpen,
    expandMenuAt: expandMenuAt,
    ref: wrapperRef,
    className: "container"
  }, children)));
};

SiteHeader.defaultProps = {
  fixed: false,
  expandMenuAt: 'lg'
};
export { SiteHeader, InnerSiteHeaderWrapper, SiteHeaderLeftWrapper, SiteHeaderLogoLink, SiteHeaderRightWrapper, SiteHeaderShell, TopNav, TopNavCollapsibleMenu, TopNavMenu, TopNavMenuItem, TopNavMenuLink, TopNavSubmenu, TopNavUserLink, TopNavHamburgerButtonWrapper, TopNavHamburgerButton, SiteHeaderContext };
export { TopNavLogo } from './siteHeader/TopNavLogo';